/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAIModel;
(function (ApiAIModel) {
    ApiAIModel["AI_MODEL_UNSPECIFIED"] = "AIModelUnspecified";
    ApiAIModel["AI_MODEL_CLAUDE"] = "AIModelClaude";
    ApiAIModel["AI_MODEL_GPT"] = "AIModelGPT";
})(ApiAIModel || (ApiAIModel = {}));
export function ApiAIModelFromJSON(json) {
    return ApiAIModelFromJSONTyped(json, false);
}
export function ApiAIModelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAIModelToJSON(value) {
    return value;
}
